import React, {createContext} from "react";
import {APIContext} from "./api_hook";
import {Metrics} from "context/models";
// Creating the context
export const MetricsContext = createContext<any>(null);

type MetricsContextType = {
    // Add the types of the context here
    children: React.ReactNode;
};

const MetricsProvider = (props: MetricsContextType) => {
    const results_per_page = 100;
    const {children} = props;
    const {fetch_api} = React.useContext(APIContext);
    const [metrics, setMetrics] = React.useState<any>([]);
    const [metrics_loading, setLoading] = React.useState<boolean>(false);
    const getMetrics = async (
        test_id: string | null,
        metrics: string | null,
        filters: string | null,
        dimensions: string | null,
        additional_query_params: any,
    ) => {
        let query_params = {
            max_results: results_per_page.toString(),
            test_id: test_id,
            ...additional_query_params,
        };
        // console.log({ query_params });
        setLoading(true);
        const options = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        };
        const resp = await fetch_api(
            "/api/get_youtube_analytics_metrics/?" +
            new URLSearchParams(query_params),
            options,
        );
        // console.log({ resp });
        setMetrics(resp);
        setLoading(false);
        return resp;
    };

    // React.useEffect(() => {
    //   // getMetrics();
    // }, []);

    return (
        <MetricsContext.Provider
            value={{
                metrics_loading,
                metrics,
                getMetrics,
                results_per_page,
            }}
        >
            {children}
        </MetricsContext.Provider>
    );
};
export default MetricsProvider;
